module.exports = __webpack_public_path__ + "static/media/2-active.92e8a212.png";